import { isBoolean } from 'lodash';
import type { MapSettingsState, SetTabSpecificSettingAction } from './types';
import { stateObjectKeyMap } from './constants';
import { applyToPerTabSettings } from './utils';

/**
 * set the current map mode setting zone polygon edit mode
 *
 * Edit mode can only be enabled while zone polygons are shown for that tab
 */
const setIsZonePolygonsEditMode = (
    state: MapSettingsState,
    action: SetTabSpecificSettingAction
): MapSettingsState => {
    const {
        payload: { mode, value: isZonePolygonsEditMode }
    } = action;

    if (!isBoolean(isZonePolygonsEditMode)) return state;

    const {
        isZonePolygonsEditMode: isZonePolygonsEditModeKey,
        showZonePolygons: showZonePolygonsKey
    } = stateObjectKeyMap;
    const isShowZonePolygons = state[mode]?.[showZonePolygonsKey];
    const newValue = Boolean(isShowZonePolygons) && isZonePolygonsEditMode;

    return applyToPerTabSettings(
        mode,
        isZonePolygonsEditModeKey,
        state,
        newValue
    );
};

export default {
    setIsZonePolygonsEditMode
};
